import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ProjectMessages from '../../../../components/DashboardComponents/ProjectMessages';

const ProjectMessagesTab = () => {
  const {
    project,
    isNewMessageOpen,
    setIsNewMessageOpen,
    newMessageRecipientId,
    setNewMessageRecipientId,
  } = useOutletContext();

  return (
    <ProjectMessages
      project={project}
      isNewOpen={isNewMessageOpen}
      onNewOpenChange={open => {
        setIsNewMessageOpen(open);
        if (!open) setNewMessageRecipientId(null);
      }}
      initialRecipientUserId={newMessageRecipientId}
    />
  );
};

export default ProjectMessagesTab;
